import React from "react";
import { departureClock } from "../utils/driverDepartures.js";

export default function DriverPortalDepartureStatus({ stop, label, pending, onCancel }) {
  if (!stop?.departure) return null;
  return <section className="rounded-[4px] border border-slate-200 bg-white px-3 py-2 text-sm">
    <p className="text-slate-700">{label ? `${label} · ` : ""}{stop.is_simulated ? "Départ simulé à" : "Départ enregistré à"} <strong className="whitespace-nowrap">{departureClock(stop)}</strong></p>
    {stop.can_cancel ? <button type="button" disabled={pending} onClick={onCancel}
      className="mt-2 rounded-[4px] border border-slate-300 bg-white px-3 py-2 text-left text-sm text-slate-700 hover:border-slate-400 hover:bg-slate-50 focus-visible:outline-accent disabled:border-slate-200 disabled:bg-slate-50 disabled:text-slate-400 disabled:opacity-100 disabled:shadow-none">
      Annuler mon départ — je suis encore sur place
    </button> : <p className="mt-1 text-xs text-slate-500">{stop.cancellation_reason}</p>}
  </section>;
}
